import { render, staticRenderFns } from "./CreateExercise.vue?vue&type=template&id=43539db6&"
import script from "./CreateExercise.vue?vue&type=script&lang=js&"
export * from "./CreateExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports